import classNames from 'classnames';

import { isMobileAppContext } from '@/services/loginService';

import styles from './index.module.scss';

const termsLink = 'https://www.onestep.co/resources/terms-and-conditions';
const privacyLink = 'https://www.onestep.co/resources/privacy-policy-2';
export const PrivacyLink = () => {
  return (
    <div className={classNames(styles.privacyLink, 'leading-5 text-xs font-normal text-center')}>
      By clicking above, you acknowledge that you have read and understood, and agree to OneStep’s{' '}
      <span>
        <a
          className="underline cursor-pointer hover:opacity-75"
          target="_blank"
          href={termsLink}
          onClick={
            isMobileAppContext()
              ? () => {
                  // This for mobile
                  window.location.replace(termsLink);
                }
              : undefined
          }
        >
          Conditions
        </a>{' '}
        and{' '}
        <a
          className="underline cursor-pointer hover:opacity-75"
          href={privacyLink}
          target="_blank"
          onClick={
            isMobileAppContext()
              ? () => {
                  window.location.replace(privacyLink);
                }
              : undefined
          }
        >
          Privacy Policy.
        </a>
      </span>
    </div>
  );
};
